import { apiClient } from 'pobble-components/dist/api'

const apiCreateAssessmentFile = data =>
  apiClient.post(`/v3/assessment_files`, data)

const apiDeleteAssessmentFile = id =>
  apiClient.delete(`/v3/assessment_files/${id}/`)

const apiInviteToAssessmentFileBulk = data =>
  apiClient.post('/v3/bulk_invite_guest_moderators', data)

export {
  apiCreateAssessmentFile,
  apiDeleteAssessmentFile,
  apiInviteToAssessmentFileBulk
}
